import { render, staticRenderFns } from "./MyValentine.vue?vue&type=template&id=3ff44593&scoped=true&"
import script from "./MyValentine.vue?vue&type=script&lang=js&"
export * from "./MyValentine.vue?vue&type=script&lang=js&"
import style0 from "./MyValentine.vue?vue&type=style&index=0&id=3ff44593&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ff44593",
  null
  
)

export default component.exports